import iconDaiCoin from "assets/img/dashboard/buy-and-sell/img/dai-coin-icon.svg"
import btcCoinIcon from "assets/img/dashboard/buy-and-sell/img/btc-coin-icon.svg"
import btcCoinIconColored from "assets/img/dashboard/buy-and-sell/img/btc-coin-icon-orange.svg"
import iconDaiCoinColored from "assets/img/dashboard/buy-and-sell/img/dai-coin-icon-yellow.svg"
import ballArs from "assets/img/dashboard/buy-and-sell/img/ball-ars.svg";
import ballUsd from "assets/img/dashboard/buy-and-sell/img/ball-usd.svg";
import ballBtc from "assets/img/dashboard/buy-and-sell/img/ball-btc.svg";
import ballDai from "assets/img/dashboard/buy-and-sell/img/ball-dai.svg";
import ballEth from "assets/img/dashboard/buy-and-sell/img/ball-eth.svg";

export const images = {
    daiCoinIcon: iconDaiCoin,
    daiCoinIconColored: iconDaiCoinColored,
    btcCoinIcon: btcCoinIcon,
    btcCoinIconColored: btcCoinIconColored,
    ethCoinIcon: btcCoinIcon,
    ethCoinIconColored: btcCoinIconColored,
    arsBall: ballArs,
    usdBall: ballUsd,
    daiBall: ballDai,
    btcBall: ballBtc,
    ethBall: ballEth,
};
